import { Union, Record } from "../../../fable_modules/fable-library-js.4.19.3/Types.js";
import { OutboundMsg_$reflection as OutboundMsg_$reflection_1, InboundMsg_$reflection as InboundMsg_$reflection_1, LocalMsg_$reflection as LocalMsg_$reflection_1, Model_$reflection as Model_$reflection_1 } from "../../../FileManagement/FileManagementTypes.js";
import { OutboundMsg_$reflection as OutboundMsg_$reflection_2, InboundMsg_$reflection as InboundMsg_$reflection_2, LocalMsg_$reflection as LocalMsg_$reflection_2, Model_$reflection as Model_$reflection_2 } from "../../../FileManagement/FileUploadSelectors/AutoZipSelector/AutoZipTypes.js";
import { union_type, class_type, record_type } from "../../../fable_modules/fable-library-js.4.19.3/Reflection.js";
import { Msg$3_$reflection } from "../../../Common/InboundOutbound.js";
import { Common_StudyStatus_$reflection } from "../../../RAWMap.Models/Common.js";

export class Model extends Record {
    constructor(fileUpload, autoZip) {
        super();
        this.fileUpload = fileUpload;
        this.autoZip = autoZip;
    }
}

export function Model_$reflection() {
    return record_type("RAWMap.Client.Study.CoreForm.CoreFile.Types.Model", [], Model, () => [["fileUpload", Model_$reflection_1()], ["autoZip", Model_$reflection_2()]]);
}

export class LocalMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ExceptionError", "ClearChildrenLists", "FileManagementMsg", "AutoZipMsg"];
    }
}

export function LocalMsg_$reflection() {
    return union_type("RAWMap.Client.Study.CoreForm.CoreFile.Types.LocalMsg", [], LocalMsg, () => [[["Item", class_type("System.Exception")]], [], [["Item", Msg$3_$reflection(LocalMsg_$reflection_1(), InboundMsg_$reflection_1(), OutboundMsg_$reflection_1())]], [["Item", Msg$3_$reflection(LocalMsg_$reflection_2(), InboundMsg_$reflection_2(), OutboundMsg_$reflection_2())]]]);
}

export class OutboundMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["DownloadableFilesUpdated", "StartedZipping", "UploadStarted", "UploadCompleted", "UploadFailed", "FileDeleted"];
    }
}

export function OutboundMsg_$reflection() {
    return union_type("RAWMap.Client.Study.CoreForm.CoreFile.Types.OutboundMsg", [], OutboundMsg, () => [[], [], [], [], [], []]);
}

export class InboundMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["RefreshFileList", "StudyStatusUpdated"];
    }
}

export function InboundMsg_$reflection() {
    return union_type("RAWMap.Client.Study.CoreForm.CoreFile.Types.InboundMsg", [], InboundMsg, () => [[], [["Item", Common_StudyStatus_$reflection()]]]);
}

export const adminOnlyDownload = "Access to DICOMs that fail verification is restricted to ViTAA Admins. Please contact ViTAA support to gain access to the file.";

